import React from 'react';
import { Container, Box, Typography, Link } from '@mui/material';
import { useLang } from '../i18n';

const TEXT = {
  ru: {
    title: 'Условия использования и Политика конфиденциальности',
    s1: '1. Сбор и использование данных',
    p1: 'Мы собираем минимально необходимые данные для работы приложения. При регистрации мы запрашиваем ваше имя и адрес электронной почты. Эта информация используется исключительно для идентификации вас в системе и для восстановления доступа к вашему аккаунту.',
    p2: 'Доска почёта. Зарегистрированным пользователям видна «доска почёта»: первое слово из указанного вами имени и количество минут занятий за день и за неделю. Email и другие данные не показываются, гостям доска не видна. Убрать себя с доски можно в любой момент: «Прогресс → Настройки → Показывать меня на доске почёта».',
    p3: 'Для работы занятий мы храним ваши ответы, время занятий и настройки — они нужны, чтобы планировать повторения и показывать ваш прогресс. Сторонняя аналитика, рекламные трекеры и cookies не используются: для входа и настроек интерфейса приложение хранит данные в памяти вашего браузера (localStorage).',
    s2: '2. Ваши права (GDPR)',
    p4: 'В соответствии с Общим регламентом по защите данных (GDPR) Европейского союза, вы имеете право на доступ, исправление и удаление ваших персональных данных.',
    p5a: 'Если вы хотите удалить свой аккаунт и все связанные с ним данные (включая ваше имя и email), пожалуйста, отправьте запрос на адрес электронной почты:',
    p5b: 'Мы обработаем ваш запрос в кратчайшие сроки.',
    s3: '3. Изменения в условиях',
    p6: 'Мы можем обновлять эти условия время от времени. Мы рекомендуем вам периодически просматривать эту страницу для получения актуальной информации.',
  },
  it: {
    title: "Condizioni d'uso e informativa sulla privacy",
    s1: '1. Raccolta e uso dei dati',
    p1: "Raccogliamo solo i dati necessari al funzionamento dell'app. Alla registrazione chiediamo nome ed email: servono esclusivamente a identificarti e a recuperare l'accesso al tuo account.",
    p2: "Albo d'onore. Gli utenti registrati vedono l'«albo d'onore»: la prima parola del nome che hai indicato e i minuti di studio del giorno e della settimana. Email e altri dati non vengono mostrati e gli ospiti non vedono l'albo. Puoi toglierti in qualsiasi momento: «Progressi → Impostazioni → Mostrami nell'albo d'onore».",
    p3: "Per far funzionare le lezioni conserviamo le tue risposte, il tempo di studio e le impostazioni: servono a pianificare i ripassi e a mostrarti i progressi. Non usiamo analytics di terze parti, tracker pubblicitari né cookie: per l'accesso e le impostazioni dell'interfaccia l'app usa la memoria del tuo browser (localStorage).",
    s2: '2. I tuoi diritti (GDPR)',
    p4: "In base al Regolamento generale sulla protezione dei dati (GDPR) dell'Unione Europea hai diritto di accedere ai tuoi dati personali, correggerli e cancellarli.",
    p5a: "Se vuoi cancellare l'account e tutti i dati collegati (compresi nome ed email), scrivi a:",
    p5b: 'Gestiremo la richiesta il prima possibile.',
    s3: '3. Modifiche alle condizioni',
    p6: 'Possiamo aggiornare queste condizioni di tanto in tanto: ti consigliamo di consultare periodicamente questa pagina.',
  },
};

const TermsOfService = () => {
  const { lang } = useLang();
  const tx = TEXT[lang] || TEXT.ru;
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          p: 4,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: 'background.paper',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>{tx.title}</Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>{tx.s1}</Typography>
        <Typography paragraph>{tx.p1}</Typography>
        <Typography paragraph>{tx.p2}</Typography>
        <Typography paragraph>{tx.p3}</Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>{tx.s2}</Typography>
        <Typography paragraph>{tx.p4}</Typography>
        <Typography paragraph>
          {tx.p5a}{' '}<Link href="mailto:boris@shbb.pro">boris@shbb.pro</Link>. {tx.p5b}
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>{tx.s3}</Typography>
        <Typography paragraph>{tx.p6}</Typography>
      </Box>
    </Container>
  );
};

export default TermsOfService;
